import React, {useEffect, useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import './HistoriquePage.scss'
import HistoriqueItem from "../../Components/HistoriqueItem/HistoriqueItem";
import BottomSheet from "../../Components/BottomSheet/BottomSheet";
import {useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {UserModel} from "../../Models/UserModel";
import Login from "../../Components/Login/login";
import {useNavigate} from "react-router-dom";
import QRCode from "react-qr-code";
import BaseButton from "../../Components/BaseButton/BaseButton";
import {DoorModel} from "../../Models/DoorModel";
import {StadiumModel} from "../../Models/StadiumModel";

const HistoriquePage: React.FC = ({}) => {
    const navigate = useNavigate()

    const user = useSelector<StateModel, UserModel | undefined>(state => state.user)
    const porte = useSelector<StateModel, DoorModel | undefined>(state => state.door)
    const pdv = useSelector<StateModel, number | undefined>(state => state.selectedPdv)
    const stadium = useSelector<StateModel, StadiumModel | undefined>(state => state.stadium)

    const [orderToShow, setOrderToShow] = useState<string>('')
    const [show, setShow] = useState(false)
    const [showLogin, setShowLogin] = useState(false)

    useEffect(() => {
        setShowLogin(!user?.id)
    }, [])

    const handleClickOrder = (reference: string) => {
        setOrderToShow(reference)
        setShow(true)
    }

    const handleClick = () => {
        if(porte) {
            navigate(`/stands?stadium=${stadium?.reference}&doorId=${porte.id}`)
        } else {
            navigate(`/menu?stadium=${stadium?.reference}&pdvId=${pdv}`)
        }
    }

    return (
        <BasePage showBack title="Historique des commandes" onLogout={() => navigate(-1)}>
            <>
                {
                    user && (
                        <>
                            {
                                user.orders && user.orders.length > 0 ? (
                                    <div className="historique">
                                        {
                                            user.orders.map((order, index) => (
                                                <HistoriqueItem key={index} order={order} onClick={() => handleClickOrder(order.reference)} />
                                            ))
                                        }
                                    </div>
                                ) : (
                                    <div className="historiqueVide">
                                        <p className="historiqueVide--title">Votre historique est vide</p>
                                        <p className="historiqueVide--text">Commandez vos articles en cliquant sur le bouton ci-dessous</p>
                                        <BaseButton onClick={handleClick} text="Voir les articles" type="filled" className="historiqueVide--btn" />
                                    </div>
                                )
                            }
                        </>
                    )
                }
            </>
            <BottomSheet show={show} close={() => setShow(false)} >
                <div className="bottomSheetQR">
                    <div className="bottomSheetQR__imgContainer">
                        <QRCode value={orderToShow} />
                    </div>
                    <p className="bottomSheetQR--numero">Commande #{orderToShow}</p>
                </div>
            </BottomSheet>
            <Login onValidate={() => setShowLogin(false)} show={showLogin} onClose={() => navigate(-1)} />
        </BasePage>
    )
}

export default HistoriquePage;
